/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { AbstractGenFirestoreService } from '@res/ngg-core';
import { OrmService, Schema } from '../schema/orm.service';
@Injectable({
  providedIn: 'root',
  deps: [],
})
export class IssuesFirestoreService extends AbstractGenFirestoreService<Schema, 'issues'> {
  constructor() {
    super(inject(OrmService).issueCollection);
  }
}
